export const mapEnLocale = {
  'map.sidebar.subTotal': 'Subtotal',
  'map.sidebar.selectSeats': 'Tickets selected',
  'map.sidebar.description': 'Tickets are not reserved yet.',
  'map.sidebar.description2': 'To secure your tickets, click "Continue".',
  'map.sidebar.maxTickets': 'Maximum of {maxTickets} tickets per purchase.',
  'map.sidebar.availableSeats': 'Available for purchase',
  'map.sidebar.continue': 'Proceed to payment',
  'map.sidebar.loading': 'Reserving tickets...',
  'map.sidebar.success': 'Tickets reserved successfully! Proceed to payment.',

  'map.dialog.perSeat': 'seat',
  'map.dialog.description': 'Maximum of {maxTickets} tickets per purchase.',
  'map.dialog.availableSeats': 'Available for purchase',
  'map.dialog.save': 'Add',

  'map.card.price': 'Ticket price:',
  'map.card.pricePlural': 'Tickets price:',

  'map.card.fee': 'Fees',

  'map.aditional.title': 'Additional sectors',
  'map.aditional.description':
    'Select the sector you want to add and then choose the number of tickets you want to buy.',
  'map.aditional.availableSeats': 'Available for purchase',
  'map.aditional.continue': 'Continue',

  'map.loading': 'Waiting for map to load...',
} as const;

export const mapEsLocale = {
  'map.sidebar.subTotal': 'Subtotal',
  'map.sidebar.selectSeats': 'Tickets seleccionados',
  'map.sidebar.description': 'Los tickets no están reservados aún.',
  'map.sidebar.description2':
    'Para asegurar tus tickets, da click en "Continuar".',
  'map.sidebar.maxTickets': 'Máximo de {maxTickets} tickets por compra.',
  'map.sidebar.availableSeats': 'Disponible para compra',
  'map.sidebar.continue': 'Continuar al pago',
  'map.sidebar.loading': 'Reservando tickets...',
  'map.sidebar.success':
    '¡Tickets reservados exitosamente! Procede a realizar el pago.',

  'map.dialog.perSeat': 'silla',
  'map.dialog.description': 'Máximo de {maxTickets} tickets por compra.',
  'map.dialog.availableSeats': 'Disponible para compra',
  'map.dialog.save': 'Agregar',

  'map.card.price': 'Precio de ticket:',
  'map.card.pricePlural': 'Precio de tickets:',
  'map.card.fee': 'Recargos',

  'map.aditional.title': 'Sectores adicionales',
  'map.aditional.description':
    'Selecciona el sector que deseas agregar y luego elige la cantidad de tickets que deseas comprar.',
  'map.aditional.availableSeats': 'Disponible para compra',
  'map.aditional.continue': 'Continuar',

  'map.loading': 'Cargando mapa, por favor espere...',
} as const;
